import { render } from "./btcMintPopup.vue?vue&type=template&id=10aa52e9"
import script from "./btcMintPopup.vue?vue&type=script&lang=js"
export * from "./btcMintPopup.vue?vue&type=script&lang=js"

import "./btcMintPopup.vue?vue&type=style&index=0&id=10aa52e9&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__